export interface ErrorLogAnalysisRequestModel {
    fromDate: string;
    toDate: string;
}

export interface ErrorLogAnalysisModel {
    controllerName: string;
    methodName: string;
    windowStart: string;
    occurrenceCount: number;
    firstOccurredOn: string;
    lastOccurredOn: string;
    errorMessage: string;
    cause: string;
    probableSolution: string;
    isSameParameter: boolean;
    distinctParamCount: number;
    parameterPattern: string;
    sampleParamDetails: string;
    sampleStackTrace: string;
    status: ErrorLogStatus;
    statusUpdatedBy: string;
    statusUpdatedOn: string;
}

export interface ErrorLogStatusUpdateModel {
    controllerName: string;
    methodName: string;
    windowStart: string;
    status: ErrorLogStatus;
}

export interface ErrorLogOccurrenceRequestModel {
    controllerName: string;
    methodName: string;
    fromDate: string;
    toDate: string;
    skip: number;
    take: number;
}

export interface ErrorLogOccurrenceModel {
    id: number;
    createdDate: string;
    controllerType: string;
    methodType: string;
    errorMessage: string;
    innerException: string;
    stackTrace: string;
    paramDetails: string;
    status: ErrorLogStatus;
    statusUpdatedBy: string;
    statusUpdatedOn: string;
}

export interface ErrorLogOccurrenceListModel {
    totalCount: number;
    items: ErrorLogOccurrenceModel[];
}

// Same values as dbo.ErrorLog.Status and ErrorLogStatus in the API (2 and 4 are retired, so the values are not renumbered).
export enum ErrorLogStatus {
    New = 1,
    Resolved = 3,
    ThirdPartyIssue = 5,
    NotConsider = 6,
    DoLaterNotPriority = 7
}

export const ErrorLogStatusList: Array<{ value: ErrorLogStatus, text: string, css: string }> = [
    { value: ErrorLogStatus.New, text: 'lblErrorStatusNew', css: 'is-new' },
    { value: ErrorLogStatus.Resolved, text: 'lblErrorStatusResolved', css: 'is-resolved' },
    { value: ErrorLogStatus.ThirdPartyIssue, text: 'lblErrorStatusThirdPartyIssue', css: 'is-third-party' },
    { value: ErrorLogStatus.NotConsider, text: 'lblErrorStatusNotConsider', css: 'is-ignored' },
    { value: ErrorLogStatus.DoLaterNotPriority, text: 'lblErrorStatusDoLaterNotPriority', css: 'is-later' }
];
